export default function customersService($http, RESOURCES) {
  function getCustomer(params) {
    params = params || '';
    return $http.get(RESOURCES.CUSTOMERS + params);
  }

  function getCustomerById(customerId) {
    return $http.get(RESOURCES.CUSTOMERS + '/parent', {
      params: {
        id: customerId,
      },
    });
  }

  function getCustomers(params) {
    return $http.get(RESOURCES.CUSTOMERS + '/customerSearch', { params: params });
  }

  function deleteCustomer(customerId) {
    return $http.delete(RESOURCES.CUSTOMERS + '/' + customerId);
  }

  function getCustomerPoints(customerId, offset = 0, limit = 500) {
    return $http.get(RESOURCES.CUSTOMERS + '/' + customerId + '/points', {
      params: {
        offset,
        limit,
      },
    });
  }

  function getCustomerRedemptionErrors(customerId, offset = 0, limit = 500) {
    return $http.get(RESOURCES.CUSTOMERS + '/' + customerId + '/redemption-errors', {
      params: {
        offset,
        limit,
      },
    });
  }

  function getCustomerReservations(customerId, offset = 0, limit = 500) {
    return $http.get(RESOURCES.CUSTOMERS + '/' + customerId + '/reservations', {
      params: {
        offset,
        limit
      },
    });
  }

  function getCustomerReferrals(customerId) {
    return $http.get(RESOURCES.CUSTOMERS + '/' + customerId + '/referrals');
  }

  function getPublishedReviews(customerId) {
    return $http.get(RESOURCES.CUSTOMERS + '/' + customerId + '/reviews/published');
  }

  function updateAccountTransferStatus(customerId, transferId, status, reason) {
    return $http.put(RESOURCES.CUSTOMERS + '/' + customerId + '/points/' + transferId + '/status', {
      status: status,
      reason: reason,
    });
  }

  function addCustomerPoints(customerId, params) {
    return $http.post(RESOURCES.CUSTOMERS + '/' + customerId + '/points/add', params);
  }

  function deductCustomerPoints(customerId, params) {
    return $http.post(RESOURCES.CUSTOMERS + '/' + customerId + '/points/deduct', params);
  }

  function updateCustomer(customerId, params) {
    return $http.put(RESOURCES.CUSTOMERS + '/' + customerId, params);
  }

  return {
    getCustomer,
    getCustomers,
    getCustomerById,
    getCustomerPoints,
    getCustomerReservations,
    getCustomerReferrals,
    getPublishedReviews,
    updateAccountTransferStatus,
    addCustomerPoints,
    updateCustomer,
    deductCustomerPoints,
    deleteCustomer,
    getCustomerRedemptionErrors,
  };
}



// WEBPACK FOOTER //
// ./src/app/customers/customers.service.js